import React, { FunctionComponent } from 'react';

import { useUnit } from 'effector-react/ssr';

import { $outProductsDialog, resetOutProductsDialog } from '@stores/dialogs/out-products';

import { applyTypograf } from '@utils/typograf';

import { Button } from '@components/common/Button/Button';
import { Dialog } from '@components/common/Dialog/Dialog';
import { Picture } from '@components/common/Picture/Picture';

import styles from './OutProductsDialog.module.scss';

export const OutProductsDialog: FunctionComponent = () => {
    const [{ isOpen, options }, resetOutProductsDialogFn] = useUnit([
        $outProductsDialog,
        resetOutProductsDialog,
    ]);
    const { items, onApply, buttonText, isLoading, isClosable = true } = options;

    const handleClose = () => {
        if (isClosable) resetOutProductsDialogFn();
    };

    return (
        <Dialog
            isOpen={isOpen}
            setOpen={handleClose}
            isClosable={isClosable}
            title="Кое-что раскупили :("
            isTitleTypograf={false}
            classes={{ content: styles.dialogContent }}
        >
            <div className={styles.main}>
                <ul className={styles.list}>
                    {items.map(({ product: { slug, primary_image, name } }) => (
                        <li className={styles.item} key={slug}>
                            <article className={styles.product}>
                                <Picture
                                    sources={primary_image}
                                    className={styles.image}
                                    classes={{ picture: styles.picture }}
                                />
                                <h4 className={styles.name}>{applyTypograf(name)}</h4>
                            </article>
                        </li>
                    ))}
                </ul>
            </div>

            <div className={styles.footer}>
                <Button
                    type="button"
                    variant="green"
                    className={styles.button}
                    onClick={onApply}
                    isLoading={isLoading}
                    isFullWith
                >
                    {buttonText}
                </Button>
            </div>
        </Dialog>
    );
};
